<div *ngIf="displayCard" class="crm-uniqueness-suggestion">
  <ng-container *ngIf="objectCardInfo$ | async as cardInfo; else loading">
    <crm-association-card [cardData]="cardInfo" [showActionsMenu]="false"></crm-association-card>
  </ng-container>
  <ng-template #loading>
    <glxy-loading-spinner [inline]="false"></glxy-loading-spinner>
  </ng-template>
</div>
